// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3HrXa","inputWrap":"Table_inputWrap__1CxIS","col":"Table_col__2Fixk","bmiTooltip":"Table_bmiTooltip__2bs3V"};